<template>
  <div class="content">
    <div class="content-box renter-info">
      <renter-enterprise v-if="!renterId" :enterpriseType="enterpriseType" @change="onChangeEnterpriseType"></renter-enterprise>
      <div class="content-box">
        <el-form :model="form" ref="form" label-width="150px" label-position="top">
          <div class="form-box">
            <p class="form-title">{{ $t('crm_renter_item_info_religion.chang_suo_xin_xi') }}</p>
            <el-row class="form-container">
              <el-col :span="12" class="form-container-left">
                <el-form-item :label="$t('crm_renter_item_info_religion.chang_suo_ming_cheng')" prop="partnerName" :rules="rules.partnerName">
                  <el-input v-model="form.partnerName" style="width: 350px"></el-input>
                </el-form-item>
                <el-form-item :label="$t('crm_renter_item_info_religion.tyshxydm')" prop="businessLicense" :rules="erpCodeRequired ? [] : rules.businessLicense">
                  <el-input v-model.trim="form.businessLicense" :disabled="!!partnerId && !propsFuncView.partner_renter_license" style="width: 350px"></el-input>
                </el-form-item>
                <el-form-item :label="$t('crm_renter_item_info_religion.nsrsbhswdjbh')" prop="buyerNumber" :rules="rules.buyerNumber">
                  <el-input v-model.trim="form.buyerNumber" style="width: 350px"></el-input>
                </el-form-item>

                <el-form-item :label="$t('crm_renter_item_info_religion.di_zhi')" prop="address" :rules="rules.address">
                  <custom-address-select :placeholder="$t('Common.com_please_select')" v-model="form.address" ref="address" style="width: 350px"></custom-address-select>
                </el-form-item>
                <el-form-item :label="$t('crm_renter_item_info_religion.xiang_xi_di_zhi')" prop="detailAddress" :rules="rules.detailAddress">
                  <el-input type="textarea" v-model="form.detailAddress" style="width: 350px"></el-input>
                </el-form-item>
                <el-form-item :label="$t('crm_renter_item_info_religion.bian_hao')" prop="partnerCode" :rules="erpCodeRequired ? [] : rules.partnerCode">
                  <el-input v-model="form.partnerCode" style="width: 350px"></el-input>
                </el-form-item>
                <el-form-item :label="$t('crm_renter_item_info_religion.wang_zhi')" prop="website" :rules="rules.website">
                  <el-input v-model="form.website" style="width: 350px"></el-input>
                </el-form-item>
                <el-form-item :label="$t('crm_renter_item_info_religion.miao_shu')" prop="partnerDesc" :rules="rules.partnerDesc">
                  <el-input type="textarea" v-model="form.partnerDesc" style="width: 350px"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="form-container-right">
                <!-- prop="imageLicense"   :rules="rules.imageLicense"-->
                <el-form-item :label="$t('crm_renter_item_info_religion.zjhdcsfrdjzsocrsb')" style="position: relative">
                  <span slot="label">
                    {{ $t('crm_renter_item_info_religion.zjhdcsfrdjzs') }}
                    <i
                      v-if="!partnerId && propsFuncView.partner_renter_ocr"
                      style="position: absolute; right: 0px; color: #0d9ae0; text-decoration: underline; font-size: 12px; cursor: pointer"
                      @click="
                        onOCR('license', {
                          partnerName: 'name',
                          businessLicense: 'regCode',
                          buyerNumber: 'regCode',
                          legalPerson: 'legalPerson',
                          detailAddress: 'address',
                        })
                      "
                    >
                      {{ $t('crm_renter_item_info_religion.OCRshi_bie_nei_rong') }}
                    </i>
                  </span>
                  <file-upload
                    :text="$t('crm_renter_item_info_religion.scyyzz')"
                    :contentStyle="{
                      width: '100%',
                      height: '200px',
                      'padding-top': '79px',
                      background: '#F5F5F5',
                    }"
                    v-model="imageLicense"
                    ref="license"
                    bizType="crm.partner.license"
                    :bizId="partnerId"
                    @effect="checkOcr"
                    :tips="$t('crm_renter_item_info_religion.qsccsyjhjggsqdxbcg2M')"
                    :autoUpload="false"
                  ></file-upload>
                </el-form-item>
                <el-form-item :label="$t('crm_renter_item_info_religion.zjhdcslogo')" prop="imageLogo" style="position: relative">
                  <file-upload
                    :text="$t('crm_renter_item_info_religion.sczjhdcslogo')"
                    :contentStyle="{
                      width: '200px',
                      height: '200px',
                      'padding-top': '79px',
                      background: '#F5F5F5',
                    }"
                    v-model="imageLogo"
                    ref="imageLogo"
                    bizType="crm.partner.logo"
                    :autoUpload="false"
                    :bizId="form.partnerOrgId"
                    :tips="$t('crm_renter_item_info_religion.qsccsjpegj2Myykhmhxs')"
                  ></file-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="tip">
              <i class="icon icon-tishi"></i>
              <span>{{ $t('crm_renter_item_info_religion.qhdysxxyzjfrdjzsxxyz') }}</span>
            </div>
            <el-row class="form-container">
              <el-col :span="12" class="form-container-left">
                <el-form-item :label="$t('crm_renter_item_info_religion.gong_si_lei_xing')" prop="partnerType" :rules="rules.partnerType">
                  <custom-select v-model="form.partnerType" code="bas_org_type" width="350px" :disabled="true"></custom-select>
                </el-form-item>

                <el-form-item :label="$t('crm_renter_item_info_religion.lian_xi_dian_hua')" prop="telephone" :rules="rules.telephone">
                  <el-input v-model="form.telephone" style="width: 350px"></el-input>
                </el-form-item>
                <el-row :gutter="8">
                  <el-col :span="18">
                    <el-form-item :label="$t('crm_renter_item_info_religion.zhu_ce_zi_jin')" prop="registeredCapital" :rules="rules.registeredCapital">
                      <el-input type="number" :min="0" v-model.number="form.registeredCapital" style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item :label="$t('crm_renter_item_info_religion.zi_jin_lei_xing')" prop="currencyUnit" :rules="rules.currencyUnit">
                      <custom-select v-model="form.currencyUnit" code="isynergy_cloud_currency" width="100%"></custom-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12" class="form-container-right">
                <el-form-item :label="$t('crm_renter_item_info_religion.gui_mo')" prop="partnerScale" :rules="rules.partnerScale">
                  <custom-select v-model="form.partnerScale" code="crm_partner_scale" width="350px"></custom-select>
                </el-form-item>
                <el-form-item :label="$t('crm_renter_item_info_religion.shi_qu')" prop="timeZoneId" :rules="rules.timeZoneId" v-if="this.timeZoneList.length > 1">
                  <custom-select v-model="form.timeZoneId" :data="timeZoneList" :auto="false" :props="{ label: 'timeZoneRegionDesc', value: 'timeZoneId' }" width="350px"></custom-select>
                </el-form-item>
                <el-form-item :label="$t('crm_renter_item_info_religion.you_xiang')" prop="email" :rules="rules.email">
                  <el-input v-model="form.email" style="width: 350px"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="form-box">
            <p class="form-title">{{ $t('crm_renter_item_info_religion.fa_ren_xin_xi') }}</p>
            <el-row class="form-container">
              <el-col :span="12" class="form-container-left">
                <el-form-item :label="$t('crm_renter_item_info_religion.fa_ren_xing_ming')" prop="legalPerson" :rules="rules.legalPerson">
                  <el-input v-model="form.legalPerson" style="width: 350px"></el-input>
                </el-form-item>
                <el-form-item :label="$t('crm_renter_item_info_religion.frsfzhm')" prop="legalPersonIdentity">
                  <el-input v-model="form.legalPersonIdentity" style="width: 350px"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="form-container-right">
                <el-form-item :label="$t('crm_renter_item_info_religion.frsfz')" prop="imageIdFace">
                  <el-row>
                    <file-upload
                      :text="$t('crm_renter_item_info_religion.sfzrxm')"
                      :contentStyle="{
                        width: '200px',
                        height: '120px',
                        'padding-top': '37px',
                        background: '#F5F5F5',
                        float: 'left',
                      }"
                      v-model="imageIdFace"
                      ref="imageIdFace"
                      bizType="crm.id.face"
                      :bizId="partnerId"
                      :autoUpload="false"
                    ></file-upload>
                    <file-upload
                      :text="$t('crm_renter_item_info_religion.sfzghm')"
                      :contentStyle="{
                        width: '200px',
                        height: '120px',
                        'padding-top': '37px',
                        background: '#F5F5F5',
                        float: 'right',
                      }"
                      v-model="imageIdReverse"
                      ref="imageIdReverse"
                      bizType="crm.id.reverse"
                      :bizId="partnerId"
                      :autoUpload="false"
                    ></file-upload>
                  </el-row>
                  <div class="tips mt-6">{{ $t('crm_renter_item_info_religion.qscqxdsfzzgsqdxbcg2M') }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="tip" style="margin-bottom: 0">
              <i class="icon icon-tishi"></i>
              <span>{{ $t('crm_renter_item_info_religion.qhdysxxyzjjzssfzxxyz') }}</span>
            </div>
          </div>
          <div class="form-box">
            <p class="form-title">{{ $t('crm_renter_item_info_religion.dgzhxx') }}</p>
            <el-row class="form-container">
              <el-col :span="12" class="form-container-left">
                <!-- <el-form-item
                  :label="$t('label_bankCode"
                  prop="bankCode"
                  :rules="rules.bankCode"
                >
                  <custom-select
                    v-model="form.bankCode"
                    url="crmBankInfoSelectIce"
                    width="100%"
                     @change="onBankCode"
                    :props="{ label: 'bankName', value: 'bankCode' }"
                  ></custom-select>
                </el-form-item> -->
                <el-form-item :label="$t('crm_renter_item_info_religion.kai_hu_yin_hang')" prop="depositBank">
                  <el-input v-model="form.depositBank" style="width: 100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="form-container-right">
                <el-form-item :label="$t('crm_renter_item_info_religion.dui_gong_zhang_hao')" prop="depositNumber">
                  <el-input v-model="form.depositNumber" style="width: 350px"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
    </div>
    <div class="btn-group">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveInfo">{{ $t('crm_renter_item_info_religion.xybszlxr') }}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import customAddressSelect from '@/components/customAddressSelect.vue';
import fileUpload from '@/components/singleFileUpload.vue';
import renterEnterprise from './renter_item_enterprise.vue';

export default {
  components: { fileUpload, customAddressSelect, renterEnterprise },
  props: {
    partnerId: [String, Number],
    enterpriseType: [String, Number], // 1-企业，2-个体工商户，3-事业单位，4-宗教活动场所，5-其他
    propsFuncView: {
      type: Object,
      default: () => ({}),
    },
    orgId: [String, Number],
  },
  data() {
    // 密码验证
    return {
      cascaderProps: {
        value: 'code',
        label: 'value',
      },
      // 宗教活动场所法人登记证书
      imageLicense: [],
      // 公司logo
      imageLogo: [],
      // 身份证id正面
      imageIdFace: [],
      // 身份证反面
      imageIdReverse: [],
      form: {
        partnerOrgId: '',
        partnerName: '',
        partnerClass: '1',
        partnerCode: '',
        telephone: '',
        email: '',
        partnerScale: '',
        address: '', // 自用不参与交互
        detailAddress: '',
        website: '',
        registeredCapital: '',
        currencyUnit: '¥',
        legalPerson: '',
        legalPersonIdentity: '',
        partnerDesc: '',
        timeZoneId: '', // 总部时区
        partnerType: 'CS', // 总部 HQ 服务SC 总代理 JV 大客户CO CS
        enterpriseType: '4', // 1-企业，2-个体工商户，3-事业单位，4-宗教活动场所，5-其他
        // 地址
        country: '',
        countryCode: '',
        province: '',
        provinceCode: '',
        city: '',
        cityCode: '',

        // 宗教活动场所法人登记证书
        businessLicense: '',
        // 纳税人识别号
        buyerNumber: '',
        // 修改的
        extendId: '',

        imageLicense: false,
        imageIdFace: false,
        imageIdReverse: false,
        // 对公信息
        depositBank: '',
        depositNumber: '',
        // bankCode: '',
        // bankName: '',
        bankcardId: '', // 银行信息  id  编辑 用
        orgId: '',
      },
      timeZoneList: [],
      // ID
      renterId: '',
      // ERP编号权限
      erpCodeRequired: false,
    };
  },
  watch: {
    partnerId(val) {
      this.renterId = val || '';
      this.getCompanyDetail();
    },
    enterpriseType(val) {
      if (val) {
        this.form.enterpriseType = val;
      }
    },
    orgId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form.orgId = val;
        }
      },
    },
  },
  computed: {
    rules() {
      return {
        // 基本信息
        partnerName: [
          {
            type: 'string',
            required: true,
            message: this.$t('crm_renter_item_info_religion.qtxcsmc'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ],
        partnerType: {
          required: true,
          message: this.$t('crm_renter_item_info_religion.qxzlx'),
        },
        timeZoneId: [
          {
            required: true,
            message: this.$t('crm_renter_item_info_religion.qing_xuan_ze_shi_qu'),
          },
        ],
        partnerCode: [
          {
            type: 'string',
            required: true,
            message: this.$t('crm_renter_item_info_religion.qtxbh'),
          },
          { max: 20, message: this.$t('Common.com_rules_length_max', [20]) },
        ],
        telephone: [
          {
            type: 'string',
            required: true,
            message: this.$t('crm_renter_item_info_religion.qtxlxdh'),
          },
          {
            validator: null,
            message: this.$t('crm_renter_item_info_religion.cdyz713gzf'),
          },
        ],
        email: [
          {
            type: 'email',
            required: true,
            message: this.$t('crm_renter_item_info_religion.qtxyx'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ],
        partnerScale: {
          required: true,
          message: this.$t('crm_renter_item_info_religion.qing_xuan_ze_gui_mo'),
        },
        businessLicense: [
          {
            required: true,
            message: this.$t('crm_renter_item_info_religion.qtxzjhdcsfrdjzs'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ],
        buyerNumber: [
          {
            required: true,
            message: this.$t('crm_renter_item_info_religion.qtxnsrsbh'),
          },
          {
            min: 6,
            max: 50,
            message: this.$t('crm_renter_item_info_religion.cdyz650gzf'),
          },
        ],
        address: [
          {
            required: true,
            type: 'array',
            message: this.$t('crm_renter_item_info_religion.qing_xuan_ze_di_zhi'),
          },
        ],
        detailAddress: [
          {
            type: 'string',
            required: true,
            message: this.$t('crm_renter_item_info_religion.qtxxxdz'),
          },
          { max: 100, message: this.$t('Common.com_rules_length_max', [100]) },
        ],

        website: { max: 100, message: this.$t('Common.com_rules_length_max', [100]) },
        registeredCapital: {
          type: 'number',
          min: 0,
          message: this.$t('crm_renter_item_info_religion.zczjbnxy0'),
        },
        legalPerson: [
          {
            required: true,
            message: this.$t('crm_renter_item_info_religion.qtxfrxm'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ],
        legalPersonIdentity: [
          {
            required: true,
            message: this.$t('crm_renter_item_info_religion.qtxfrsfzhm'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ], // 数字或字母
        partnerDesc: { max: 200, message: this.$t('Common.com_rules_length_max', [200]) },
        imageLicense: {
          type: 'string',
          required: true,
          message: this.$t('crm_renter_item_info_religion.qsczjhdcsfrdjzs'),
        },
        imageIdFace: {
          type: 'string',
          required: true,
          message: this.$t('crm_renter_item_info_religion.qscsfzzfm'),
        },
        imageIdReverse: {
          type: 'string',
          required: true,
          message: this.$t('crm_renter_item_info_religion.qscsfzghm'),
        },
        depositBank: {
          type: 'string',
          required: true,
          message: this.$t('crm_renter_item_info_religion.qtxkhyh'),
        },
        depositNumber: {
          type: 'string',
          required: true,
          message: this.$t('crm_renter_item_info_religion.qtxdgzh'),
        },
      };
    },
  },
  mounted() {
    // this.renterId = this.getJump('renterId');
    this.renterId = this.partnerId || '';
    this.form.enterpriseType = this.enterpriseType;
    this.getCompanyDetail();
    // ocr识别权限全在总部上管理
    // this.getFuncView('/customer/renter');
    this.rules.registeredCapital.validator = (rule, value, callback) => {
      if (value && !(/(^[1-9]\d*$)/).test(value)) {
        callback(new Error());
      } else {
        callback();
      }
    };
    this.rules.telephone[1].validator = this.$mobilePhoneValidator;
    // 查字典
    this.getDictionary('cloud_erpCode_control', () => {
      this.erpCodeRequired = this.$searchSiteCodeFunction('cloud_erpCode_control');
    });
  },
  methods: {
    getCompanyDetail: function () {
      if (!this.renterId) {
        this.getTimeZoneList(true);
        return;
      }
      this.$getJSON(apis.partnerInfo, { partnerId: this.renterId }).then((res) => {
        if (res.code === 0) {
          const data = res.data;

          this.$setFormatData(this.form, data);
          this.form.address = [];
          if (data.countryCode) {
            this.form.address.push(data.countryCode);
          }
          if (data.provinceCode) {
            this.form.address.push(data.provinceCode);
          }
          if (data.cityCode) {
            this.form.address.push(data.cityCode);
          }
          this.form.partnerClass = `${data.partnerClass}`;
          this.form.currencyUnit = `${data.currencyUnit}`;
          this.form.partnerType = data.partnerType;
          // 数字转字符串
          this.form.registeredCapital = +data.registeredCapital;
          // 宗教活动场所法人登记证书
          this.businessLicenseImageList = this.businessLicenseImageList || [];
          this.idImageList = this.idImageList || [];
          this.getTimeZoneList(false);
        }
      });
    },
    onChangeEnterpriseType: function (num) {
      const enterpriseType = num || 1;
      this.$emit('input', enterpriseType);
    },
    // 获取时区列表
    getTimeZoneList: function (isInit) {
      this.$getJSON(apis.timeZoneGetCompanyList, { orgId: this.orgId }).then((res) => {
        this.timeZoneList = res.data;
        if (this.timeZoneList.length > 0 && isInit) {
          this.form.timeZoneId = this.timeZoneList[0].timeZoneId;
        }
      });
    },
    // 图片校验
    checkImg() {
      // if (this.imageLicense.length > 0) {
      //   this.form.imageLicense = 'imageLicense';
      // } else {
      //   this.form.imageLicense = null;
      // }
      if (this.imageIdFace.length > 0) {
        this.form.imageIdFace = 'imageIdFace';
      } else {
        this.form.imageIdFace = '';
      }
      if (this.imageIdReverse.length > 0) {
        this.form.imageIdReverse = 'imageIdReverse';
      } else {
        this.form.imageIdReverse = '';
      }
    },
    // ocr校验
    checkOcr() {
      // if (!this.renterId) {
      //   // this.form.partnerName = arg.name;
      //   // this.form.businessLicense = arg.regCode;
      //   this.onOCR('license', {
      //     name: 'partnerName',
      //     regCode: 'businessLicense',
      //     address: 'detailAddress',
      //   });
      // }
      this.checkImg();
    },
    onOCR(refName, keyMap) {
      this.$refs[refName].ocr().then((data) => {
        Object.keys(keyMap).forEach((key) => {
          this.form[key] = data[keyMap[key]];
        });
      });
    },
    // 取消
    onCancel: function () {
      this.$emit('cancel');
    },
    // 保存基本信息
    async saveInfo() {
      await Promise.all([this.$refs.license.submit(), this.$refs.imageLogo.submit(), this.$refs.imageIdFace.submit(), this.$refs.imageIdReverse.submit()]);
      this.checkImg();
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        // 赋值 国家城市镇区
        const addressMsg = this.$refs.address.getAddressMsg();
        this.$setFormatData(this.form, addressMsg);

        // 图片保存
        this.form.partnerInstructionList = [...this.imageLicense, ...this.imageIdFace, ...this.imageIdReverse];
        // logo
        this.form.logoInfo = this.imageLogo.length > 0 ? this.imageLogo[0] : null;
        // 保存交互
        if (this.renterId) {
          // renterId id  编辑要放进参数里面
          this.form.partnerId = this.renterId;
          this.$postJSON(apis.partnerUpdate, this.form).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_modify_success'),
                type: 'success',
              });
              this.$emit('success', 2);
              // this.jump('/distributor/serviceCompany', { refresh: true }, true);
            }
          });
        } else {
          //
          this.$postJSON(apis.partnerAdd, this.form).then((res) => {
            this.$emit('syncPartnerId', res.data.partnerId, res.data.partnerOrgId);
            this.$emit('success', 2);
          });
        }
      });
    },

    // 关闭弹窗
    closeDialog: function () {
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss">
@import '../../../../style/colors.scss';
.renter-info {
  padding: 14px 24px 0;
  .form-box {
    margin-top: 35px;
    position: relative;
    border: 1px solid rgba(13, 154, 224, 0.3);
    padding: 34px 24px 24px;
    .form-container {
      width: 900px;
      display: flex;
      .form-container-left {
        width: 350px !important;
        margin-right: 24px;
      }
      .form-container-right {
        width: 414px !important;
        flex: 0 0 414px;
      }
    }
    .form-title {
      font-size: 12px;
      font-weight: 600;
      color: rgba(13, 154, 224, 1);
      line-height: 20px;
      height: 20px;
      position: absolute;
      top: -10px;
      left: 16px;
      background: #ffffff;
      padding: 0 10px;
    }
    .tip {
      background: rgba(53, 184, 224, 0.15);
      border-radius: 2px;
      margin: 8px 0 24px;
      padding-left: 10px;
      .icon {
        color: #0d9ae0;
        font-size: 12px;
        margin-right: 10px;
      }
      span {
        line-height: 32px;
        color: #6c757d;
        font-size: 12px;
      }
    }
  }
  .form-box:first-of-type {
    margin-top: 0;
  }
}
</style>
